import { AutocompleteItem, ChipsInput } from '@prismamedia/one-components';
import { FC } from 'react';
import {
  ArticleFormat,
  BrandKey,
  GetSearchEnabledTagsQuery_query_searchTags_Tag,
  TagType,
} from '../../../../__generated__/queries-web';
import { useSearchEnabledTagsGetter } from '../../../../apollo/queries/getEnabledTags.web.graphql';
import { isTagInactive } from '../../../Tags/utils';
import {
  ALLOWED_TAG_TYPES_FOR_SEARCH,
  ALLOWED_TAG_TYPES_FOR_SEARCH_TV,
} from '../../../Tags/TagItems/Default/constants';
import { brandsOptions } from '../../../../utils/brands';

interface TagsInputProps {
  value?: AutocompleteItem[];
  className?: string;
  onChange?: (items: AutocompleteItem[]) => void;
  brandKey: BrandKey;
  articleFormat: ArticleFormat;
}

export const TagsInput: FC<TagsInputProps> = ({
  value,
  className,
  onChange,
  articleFormat,
  brandKey,
}) => {
  const searchTags = useSearchEnabledTagsGetter();
  const getSecondaryLabel = (
    tag: GetSearchEnabledTagsQuery_query_searchTags_Tag,
  ) => {
    const articleCount = tag.articleUsages?.find(
      (usage) => usage.brandKey === brandKey,
    )?.total;

    if (articleFormat === ArticleFormat.Rich) {
      return `${tag.type} - ${articleCount || 0} article${
        (articleCount || 0) > 1 ? 's' : ''
      }`;
    }
    return tag.type;
  };

  const { mediaProgramsAllowed } = brandsOptions[brandKey];
  const tagTypes =
    articleFormat === ArticleFormat.Video
      ? [TagType.Video]
      : mediaProgramsAllowed
      ? ALLOWED_TAG_TYPES_FOR_SEARCH_TV
      : ALLOWED_TAG_TYPES_FOR_SEARCH;

  const fetchList = (search: string) =>
    searchTags({ search, type: tagTypes }).then((tags) =>
      tags?.map((tag) => ({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: tag.id!,
        label: tag.title,
        secondaryLabel: getSecondaryLabel(tag),
        isInactive: isTagInactive(tag, brandKey),
      })),
    );

  return (
    <ChipsInput
      label="Tags"
      value={value}
      onChange={onChange}
      className={className}
      autocomplete={{ fetchList, mandatoryInput: true }}
    />
  );
};
